/** Estructura principal: barra lateral estilo Portal CJI (logo + Volver a Funcionarios). */

import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { alias } from './Comunes';

const URL_FUNCIONARIOS = import.meta.env.VITE_URL_FUNCIONARIOS || 'https://cji-portal-paneles.web.app';
const LOGO = `${URL_FUNCIONARIOS}/logoredondo.png`;

const ITEMS = [
  { to: '/', clave: 'dashboard', icono: 'bx-bar-chart-alt-2', texto: 'Dashboard Préstamos', end: true },
  { to: '/buscar', clave: 'buscar', icono: 'bx-search', texto: 'Buscar Expediente' },
  { to: '/crear', clave: 'crear', icono: 'bx-file', texto: 'Crear Expediente' },
  { to: '/mis-documentos', clave: 'misDocumentos', icono: 'bx-file-find', texto: 'Mis Documentos' },
  { to: '/adjuntar', clave: 'adjuntar', icono: 'bx-paperclip', texto: 'Adjuntar Documentos' },
  { to: '/turnos', clave: 'reportes', icono: 'bx-line-chart', texto: 'Reportes y Turnos' },
  { to: '/cambio-oficina', clave: 'cambioOficina', icono: 'bx-transfer-alt', texto: 'Cambio Oficina' },
];

export function Layout() {
  const { esAdmin, usuario, perfil, cerrarSesion } = useAuth();
  const activo = ({ isActive }: { isActive: boolean }) => (isActive ? 'activo' : '');

  // El admin ve todo. Para los demás, `accesos` manda siempre: un array vacío
  // significa "sin módulos". (Antes, al quedar vacío se mostraba el menú
  // completo, así que desactivarle todo a alguien no tenía ningún efecto.)
  const accesos: string[] = Array.isArray(perfil?.accesos) ? perfil!.accesos : [];
  const visibles = esAdmin ? ITEMS : ITEMS.filter((it) => accesos.includes(it.clave));

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="marca">
          <div className="logo">
            <img src={LOGO} alt="CJI" onError={(e) => { (e.currentTarget.style.display = 'none'); }} />
          </div>
          <div className="txt">
            Centro Jurídico Internacional
            <small>Trazabilidad de Carpetas</small>
          </div>
        </div>

        <nav>
          <div className="grupo">Principal</div>
          {visibles.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} className={activo}>
              <i className={`bx ${it.icono} icon`} /><span className="txt">{it.texto}</span>
            </NavLink>
          ))}

          {esAdmin && (
            <>
              <div className="grupo">Administración</div>
              <NavLink to="/administracion" className={activo}>
                <i className="bx bx-cog icon" /><span className="txt">Administración</span>
              </NavLink>
            </>
          )}
        </nav>

        <div className="pie">
          <div className="quien" title={usuario?.email ?? ''}>
            <i className="bx bx-user-circle icon" />
            <span className="txt">{alias(usuario?.email) || '—'}</span>
          </div>
          <a className="volver" href={URL_FUNCIONARIOS}>
            <i className="bx bx-arrow-back icon" /><span className="txt">Volver a Funcionarios</span>
          </a>
          {/* Cerrar sesión: imprescindible en el computador de la oficina (kiosco). */}
          <button className="volver salir" onClick={() => void cerrarSesion()}>
            <i className="bx bx-log-out icon" /><span className="txt">Cerrar sesión</span>
          </button>
        </div>
      </aside>

      <div className="contenido">
        <Outlet />
      </div>
    </div>
  );
}
